import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { InputSearchService } from 'src/app/aplicaciones-modulos/financiero/services/inputSearch/input-search.service';
import { LfsaBotonEditarGridComponent } from '../lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
declare var $: any;

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LfsaInputSearchComponent),
  multi: true
};

@Component({
  selector: 'app-lfsa-input-search',
  templateUrl: './lfsa-input-search.component.html',
  styleUrls: ['./lfsa-input-search.component.css'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class LfsaInputSearchComponent implements OnInit {

  @Input() path: string;
  @Input() label: string;
  @Input() control: any;
  @Input() type = 'text';
  @Input() placeholder?: string;
  @Input() isReadOnly = false;
  @Input() claseLabel = '';

  @Output() devolverAccion = new EventEmitter<any>();

  openModal() {
    this.devolverAccion.emit('');
  }

  // mostrar = false;
  // columnDefs: any[];
  // rowData: any[];
  // frameworkComponents: any;
  // rowSelection: any;
  private innerValue: any;
  // loading = false;

  // formulario: FormGroup;

  n = new Date();
  // Año
  y = this.n.getFullYear();
  // Mes
  m = this.n.getMonth() + 1;
  // Día
  d = this.n.getDate();

  fechaActual = this.y + '/' + this.m + '/' + this.d;

  constructor(private fb: FormBuilder,
    private service: InputSearchService
  ) {
    // debugger
    // jQuery('body').removeClass('modal-open');
    // jQuery('.modal-backdrop').remove();
   }

  ngOnInit() {
    // debugger
    // $(document).ready(() => {
        // $('body').removeClass('modal-open');
      // $('.modal-backdrop').remove();
        // $('.show').remove();
        // $('.modal-backdrop').remove();
        // $('body').removeClass( "modal-open" );
        // $('.modal').removeClass( "modal-backdrop" );
    // });
    // this.formulario = this.fb.group({
    //   codigo1: ['', [Validators.required]],
    //   codigo2: ['', [Validators.required]],
    //   ruc1: ['', [Validators.required]],
    //   ruc2: ['', [Validators.required]],
    //   nombre: ['', [Validators.required]]
    // });

    // this.frameworkComponents = {
    //   buttonRenderer: LfsaBotonEditarGridComponent,
    // };

    // this.columnDefs = [
    //   {
    //     headerName: 'ID',
    //     field: 'idCliente',
    //     sortable: true,
    //     // checkboxSelection: true,
    //     // headerCheckboxSelection: true,
    //     width: 150,
    //     filter: true,
    //   },
    //   {
    //     headerName: 'RUC',
    //     field: 'rucCliente',
    //     sortable: true,
    //     filter: true,
    //   },
    //   {
    //     headerName: 'NOMBRE CLIENTE',
    //     field: 'nombreCliente1',
    //     sortable: true,
    //     filter: true,
    //   },
    //   {
    //     headerName: '',
    //     cellRenderer: 'buttonRenderer',
    //     width: 200,
    //     cellRendererParams: {
    //       onClick: this.selectLinea.bind(this),
    //       label: 'Seleccionar',
    //       colorBoton: 'btn btn-info'
    //     }
    //   }
    // ];

    // this.rowSelection = 'multiple';

    // this.rowData = [];

  }

  abrirModal() {
    document.getElementById('abrirModalSustento').click();
  }

  // mostrarTabla() {
  //   console.log(this.formulario.value);
  //   this.loading = true;
  //   console.log(this.path);
  //   this.mostrar = true;
  //   let codIni = this.formulario.get('codigo1').value;
  //   let codFin = this.formulario.get('codigo2').value;
  //   let rucIni = this.formulario.get('ruc1').value;
  //   let rucFin = this.formulario.get('ruc2').value;
  //   let nombre = this.formulario.get('nombre').value;
  //   this.service.getClienteParams(codIni, codFin, rucIni, rucFin, nombre).subscribe((res: any) => {
  //     // debugger
  //     // const respuesta: any = res;
  //     this.rowData = res;
  //     this.loading = false;
  //   }, (err) => {
  //     console.log(err);
  //     this.loading = false;
  //   });
  // }


  // mostrarFormulario() {
  //   this.mostrar = false;
  //   this.formulario.setValue({
  //     codigo1: '',
  //     codigo2: '',
  //     ruc1: '',
  //     ruc2: '',
  //     nombre: ''
  //   });
  //   this.rowData = [];
  // }

  // selectLinea({ rowData }) {
  //   this.mostrar = false;
  //   // this.closebutton.nativeElement.click();
  //   this.value = rowData.descripcion;
  //   //this.devolverAccion.emit(rowData.idCliente);
  //   this.devolverAccion.emit(rowData);
  // }

  get value() {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCb(v);
    }
  }

  onChangeCb: (_: any) => void = () => { };
  onTouchedCb: (_: any) => void = () => { };

  writeValue(v: any): void {
    this.value = v;
  }

  registerOnChange(fn: any): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isReadOnly = isDisabled;
  }

}
